import { render, staticRenderFns } from "./quoteBlock.vue?vue&type=template&id=65047d46&scoped=true&"
import script from "./quoteBlock.vue?vue&type=script&lang=js&"
export * from "./quoteBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65047d46",
  null
  
)

export default component.exports